// =============================================================================
// features/configuracoes/comercial/SettingsCard.tsx — Card de grupo canônico
// da tela (DS §elev-2, sem hover — não é navegável, é conteúdo).
// =============================================================================

import * as React from 'react';

import { Badge } from '../../../components/ui/Badge';

interface SettingsCardProps {
  title: string;
  description: string;
  /** Mostra o selo "Padrão" quando o grupo ainda não foi explicitamente configurado. */
  isDefault?: boolean;
  children: React.ReactNode;
}

export function SettingsCard({
  title,
  description,
  isDefault = false,
  children,
}: SettingsCardProps): React.JSX.Element {
  return (
    <section
      className="flex flex-col gap-4 p-5 rounded-md"
      style={{
        background: 'var(--bg-elev-1)',
        boxShadow: 'var(--elev-2)',
        border: '1px solid var(--border)',
      }}
      aria-labelledby={`${title}-heading`}
    >
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h2
            id={`${title}-heading`}
            className="font-sans font-semibold text-ink"
            style={{ fontSize: 'var(--text-base)' }}
          >
            {title}
          </h2>
          <p className="mt-0.5 font-sans text-ink-3" style={{ fontSize: 'var(--text-xs)' }}>
            {description}
          </p>
        </div>
        {isDefault && <Badge variant="neutral">Usando padrão</Badge>}
      </div>

      <div className="flex flex-col gap-4">{children}</div>
    </section>
  );
}
